import { ReactNode } from "react";

import Box from "../Box";
import styles from "./styles.module.css";

type PageInfoHeaderActionsProps = {
  children: ReactNode;
};

const PageInfoHeaderActions = ({ children }: PageInfoHeaderActionsProps) => (
  <Box align="center" className={styles.actions}>
    {children}
  </Box>
);

PageInfoHeaderActions.displayName = "DS.PageInfoHeaderActions";

export default PageInfoHeaderActions;
